const MultiSelects = ({additionalSelects, setAdditionalSelects, handleAdditionalSelectChange, chartNames}) => {
    let all_options = ['Choose', ...chartNames]
    
    return (
        <div>
            {additionalSelects.map((dropdown) => (
                <div key={dropdown.id} className="flex items-center mb-2">
                    <select
                        value={dropdown.selected}
                        onChange={(e) => handleAdditionalSelectChange(setAdditionalSelects, dropdown.id, e.target.value)}
                        className="choice-select"
                    >
                        {all_options.map(chartname => (
                            <option
                                key={chartname}
                                value={chartname}
                            >
                                {chartname}
                            </option>
                        ))}
                    </select>
                </div>
            ))}
        </div>           
    )
}
export default MultiSelects;
